import { useCallback } from 'react'

import { useLocalStorage } from '../../hooks/useLocalStorage'

export const useOpenPath = (treeId: string) => {
  const [expandedPaths, setExpandedPaths] = useLocalStorage<string[]>(
    `expandedPaths@${treeId}`,
  )

  return useCallback(
    (path: string) => {
      const pathParts = path.split('.').filter(Boolean)
      const partialPaths = []

      for (let i = 1; i <= pathParts.length; i++) {
        const partialPath = pathParts.slice(0, i).join('.')
        if (!expandedPaths?.includes(partialPath)) {
          partialPaths.push(partialPath)
        }
      }

      if (partialPaths.length) {
        setExpandedPaths([...(expandedPaths ?? []), ...partialPaths])
      }
    },
    [expandedPaths, setExpandedPaths],
  )
}
